import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import './back.css'

const BackIcon: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="back-icon-modern-container">
      <IconButton onClick={handleBack} aria-label="Go back">
        <ArrowBackIcon className="back-arrow-modern" />
      </IconButton>
    </div>

  );
};

export default BackIcon;
